import { useEffect } from "react";
import { APP_LINK_login } from "../../CONSTANTS";
import { isMobile } from "../../Utils";

function LoginRedirect() {
  useEffect(() => {
    if (isMobile()) {
      window.location.href = APP_LINK_login;
    }
  }, []);

  return null;
}

export default LoginRedirect;
